<template>
  <el-dialog :title="sales ? '选择应收明细' : '选择应付明细'" :visible.sync="inner" width="860px" append-to-body :close-on-click-modal="false" @open="load">
    <el-table :data="list" border height="360" @selection-change="rows => selected = rows">
      <el-table-column type="selection" width="46" />
      <el-table-column :prop="sales ? 'receivableCode' : 'payableCode'" :label="sales ? '应收单号' : '应付单号'" width="150" />
      <el-table-column prop="materialCode" label="编码" width="130" />
      <el-table-column prop="materialName" label="名称" min-width="140" />
      <el-table-column prop="quantity" label="数量" width="90" align="right" />
      <el-table-column prop="price" label="单价" width="100" align="right" />
      <el-table-column prop="remainAmount" label="可开票" width="110" align="right" />
    </el-table>
    <span slot="footer">
      <el-button @click="inner = false">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import request from '../api/request'
export default {
  props: { visible: Boolean, partnerId: String, excludeId: { type: String, default: '' }, sales: { type: Boolean, default: true } },
  data() { return { list: [], selected: [] } },
  computed: {
    inner: { get() { return this.visible }, set(v) { this.$emit('update:visible', v) } }
  },
  methods: {
    load() {
      if (!this.partnerId) { this.list = []; return }
      request.get('/finance/invoice/pendingLines', {
        params: { kind: this.sales ? 'invoiceSales' : 'invoicePurchase', partnerId: this.partnerId, excludeId: this.excludeId || '' }
      }).then(res => { this.list = res.data || [] }).catch(() => {})
    },
    confirm() {
      if (!this.selected.length) { this.$message.warning('请选择明细'); return }
      this.$emit('select', this.selected.map(row => ({ ...row, totalMoney: Number(row.remainAmount || 0) })))
      this.inner = false
    }
  }
}
</script>
